// import axios from "@/axios"; 
import axiosSync from "@/axiosSync";
// import axios from "@/axios";

export function usePortInfoVsolGponApi() {
  async function getBasicInfo(olt_id) {
    const response = await axiosSync.get(`/vsol-gpon/api?oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPonPortData(olt_id) {
    const response = await axiosSync.get(`/vsol-gpon/api?oltid=${olt_id}&type=poninfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getUpLinkData(olt_id) {
    const response = await axiosSync.get(`/vsol-gpon/api?oltid=${olt_id}&type=uplinkportdb&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
 async function getSingleOnuData(port_number, olt_id) {
    console.log('VSOL Service - Processing:', { port_number, olt_id });
    
    // Support both GPON and EPON formats:
    // - GPON0/1:1, GPON1/1:1
    // - EPON0/1:1, EPON1/1:1
    // - 0/1:1, 1/1:1 (without prefix)
    const matches = port_number.match(/(GPON|EPON)?\d*\/(\d+):(\d+)/i);
    
    if (!matches) {
      throw new Error(`Invalid port number format: ${port_number}. Expected format like GPON0/1:1 or EPON1/1:1`);
    }
    
    const ponid = matches[2];  // The part after / and before :
    const onuid = matches[3];  // The part after :
    
    console.log('VSOL Service - Parsed:', { ponid, onuid });
    
    const url = `/vsol-gpon/api?oltid=${olt_id}&type=reltimevalueonu&ponid=${ponid}&onuid=${onuid}`;
    console.log('VSOL Service - API URL:', url);
    
    const response = await axiosSync.get(url);
    console.log('VSOL Service - Response received');
    
    return response.data;
}
  async function getViberDownDectect(olt_id) {
    const response = await axiosSync.get(`/vsol-gpon/api?oltid=${olt_id}&type=fiberdowndetact&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }



  return {
    getBasicInfo,
    getPonPortData,
    getUpLinkData,
    getSingleOnuData,
    getViberDownDectect
  };
}
